export const INDUSTRIES = [
  "Accounting",
  "Aerospace & Defense",
  "Agriculture",
  "Automotive",
  "Banking & Finance",
  "Biotechnology",
  "Chemicals",
  "Construction",
  "Consulting",
  "Consumer Goods",
  "E-commerce",
  "Education",
  "Energy & Utilities",
  "Engineering",
  "Entertainment & Media",
  "Fitness & Wellness",
  "Food & Beverage",
  "Government",
  "Healthcare",
  "Hospitality & Tourism",
  "Human Resources",
  "Information Technology",
  "Insurance",
  "Legal",
  "Logistics & Supply Chain",
  "Manufacturing",
  "Marketing & Advertising",
  "Mining",
  "Nonprofit",
  "Oil & Gas",
  "Pharmaceuticals",
  "Professional Services",
  "Public Relations",
  "Publishing",
  "Real Estate",
  "Restaurants & Catering",
  "Retail",
  "Security Services",
  "Sports & Recreation",
  "Telecommunications",
  "Textiles & Apparel",
  "Transportation",
  "Veterinary Services",
  "Warehousing",
  "Waste Management",
  "Wholesale & Distribution",
  "Other",
];
